import { render } from "./TreeMultiselectOption.vue?vue&type=template&id=20e261e0&scoped=true&ts=true"
import script from "./TreeMultiselectOption.vue?vue&type=script&lang=ts"
export * from "./TreeMultiselectOption.vue?vue&type=script&lang=ts"

import "./TreeMultiselectOption.vue?vue&type=style&index=0&id=20e261e0&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e261e0"]])

export default __exports__